/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Extract_Start_LogInputs */



/**
* | output |
* | --- |
* | "Starting extraction process..." |
*
* @param {Drastic_Tech_Extract_Start_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_extract_start_log = /** @type {((inputs?: Drastic_Tech_Extract_Start_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Extract_Start_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Demarrage du processus d'extraction...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Extraktionsprozess wird gestartet...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avvio del processo di estrazione...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начало процесса экстракции...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciando proceso de extracción...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开始萃取过程……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("抽出プロセスを開始しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निष्कर्षण प्रक्रिया शुरू हो रही है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Iniciando o processo de extração...")
	return /** @type {LocalizedString} */ ("Starting extraction process...")
});